export default __webpack_public_path__ + "static/media/indicativo-nascimento-cras.f8f7287a.svg";